import { createVNode as i, mergeProps as n } from "vue";
import l from "../node_modules/@pf-ui/pf-icon-svg/es/asn/NextOutlined.js";
import m from "../components/PfIcon.js";
const t = (e, r) => {
  const o = {
    ...e,
    ...r.attrs
  };
  return i(m, n(o, {
    icon: l
  }), null);
};
t.displayName = "NextOutlined";
t.inheritAttrs = !1;
export {
  t as default
};
